export default "__VITE_ASSET__In01oMlg__"